const STORAGE_KEY = 'site_version'

export function setSiteVersion(version) {
  window.localStorage.setItem(STORAGE_KEY, version === '2' ? '2' : '1')
}



// WEBPACK FOOTER //
// ./src/config/siteVersion.js